import * as React from "react";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "@egds/react-core/layout-flex";
import { UitkSheet, UitkSheetTransition } from "@egds/react-core/sheet";
import { UitkFigure, UitkImage, UitkFigureAspectRatioType } from "@egds/react-core/images";
import { UitkLink } from "@egds/react-core/link";
import { UitkSpacing } from "@egds/react-core/spacing";
import { UitkText } from "@egds/react-core/text";
import { TrackedLink } from "src/components/utility/analytics/TrackedLink";
import { LocalizedComponentClass, withLocalization } from "bernie-l10n";
import { useLocalization } from "@shared-ui/localization-context";
import { HotelSearchLinkBuilder } from "components/utility/HotelSearchLinkBuilder/HotelSearchLinkBuilder";

export interface MapPoiSheetProps {
  id: string;
  title?: string;
  distance?: string;
  photoUrl?: string;
  description?: string;
  isVisible?: boolean;
}

export const MapPoiSheet = withLocalization((props: MapPoiSheetProps) => {
  const { id, title, photoUrl, description, isVisible } = props;
  const { formatText } = useLocalization();

  if (!title || !isVisible) {
    return null;
  }

  return (
    <UitkSheetTransition isVisible={isVisible}>
      <UitkSheet className="MapHotelCard" isVisible={isVisible} triggerRef={null}>
        <UitkLayoutFlex wrap="nowrap">
          <MapSheetImage photoUrl={photoUrl} photoAlt={title} />
          <UitkSpacing padding="three">
            <UitkLayoutFlexItem>
              <div>
                <UitkText size={400} weight="bold">
                  {title}
                </UitkText>
                {!!description && (
                  <UitkSpacing padding={{ blockstart: "half", blockend: "one" }}>
                    <div>{description}</div>
                  </UitkSpacing>
                )}
                <UitkLink inline>
                  <TrackedLink
                    moduleName="Maps"
                    href={new HotelSearchLinkBuilder().withDaysInFuture().withStayLength().withRegionId(id).build()}
                    linkName="poiSheet"
                    rfrr="CTA.HSR"
                  >
                    {formatText("maps.sheets.poi.seeNearby")}
                  </TrackedLink>
                </UitkLink>
              </div>
            </UitkLayoutFlexItem>
          </UitkSpacing>
        </UitkLayoutFlex>
      </UitkSheet>
    </UitkSheetTransition>
  );
}) as LocalizedComponentClass<MapPoiSheetProps>;

interface MapSheetImageModel {
  photoUrl?: string;
  photoAlt?: string;
}

export const MapSheetImage = ({ photoUrl, photoAlt }: MapSheetImageModel) => {
  if (!photoUrl) {
    return null;
  }

  return (
    <UitkLayoutFlexItem minWidth="quarter_width">
      <div>
        <UitkFigure ratio={UitkFigureAspectRatioType.R4_1} imageFit="cover">
          <UitkImage src={photoUrl} alt={photoAlt} placeholderImage />
        </UitkFigure>
      </div>
    </UitkLayoutFlexItem>
  );
};

export default MapPoiSheet;
